import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default ({
  // user,
  domain,
  object,
}) => new Promise((resolve) => {
  nsApi.get({
    object,
    action: 'list',
    domain,
    // user,
  }).then((res) => {
    resolve(res || []);
  }).catch((err) => {
    console.error(err);
    resolve(false);
  });
});
